import { createAction } from '@reduxjs/toolkit';

import type { IApiStore } from '../../../../../models/ecommerce/store/storeModel';
import type { TimeslotSource } from '../../../tracking/ga4/cnc/ga4Cnc';
import type {
    StoreChangeNotificationType,
    WeeklyMenuModalType,
} from '../../structureDefinitions/modalState';
import type { CncStep } from '../../structureDefinitions/uiState';

export type MiniCartNotificationType =
    | StoreChangeNotificationType.timeslotSelected
    | WeeklyMenuModalType.addToCart;

type MiniCartCncStep = {
    step: CncStep.MiniCart;
    param?: {
        notification?: MiniCartNotificationType;
    };
};

type TimeSlotsCncStep = {
    step: CncStep.TimeSlots;
    param?: {
        expressStore?: IApiStore;
        timeslotSource?: TimeslotSource;
    };
};

type PostalCodePreviewCncStep = {
    step: CncStep.PostalCodePreview;
    param: {
        previewPostalCode: string;
    };
};

type MapCncStep = {
    step: CncStep.Map;
    param: {
        preselectedStore: IApiStore | null;
    };
};

type PostalCodeSelectorCncStep = {
    step: CncStep.PostalCodeSelector;
};

export type CncNavigatePayload =
    | MiniCartCncStep
    | TimeSlotsCncStep
    | PostalCodePreviewCncStep
    | MapCncStep
    | PostalCodeSelectorCncStep;

export const cncNavigateTo = createAction<CncNavigatePayload>('cnc/navigateTo');

export const cncSetTo = createAction<CncNavigatePayload>('cnc/setTo');
